<template>
  <div class="container">
    <div class="preloader" v-if="addPreloader">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <form class="feedback" @submit.prevent="sendForm()">
      <p class="title">Спасибо за контроль отстройки!</p>
      <textarea
        placeholder="Оставить комментарий по работе с клиентом"
        v-model="comment"
      ></textarea>

      <input type="submit" value="отправить" />
    </form>
  </div>
</template>
<script>
export default {
  data: () => ({
    comment: "",
    addPreloader: false,
  }),
  methods: {
    // Отправить комментарий
    sendForm() {
      let data = {
        reportId: this.$route.params.id,
        comment: this.comment,
      };
      this.$store.dispatch("CONTROL_ADD_COMMENT", data).then((r) => {
        this.addPreloader = true;
        if (r.status == 200) {
          this.$makeToast("Поздравляем!", "success", `Комментарий сохранен! Отчет отправлен на Ваш e-mail`);
          // this.$localStorageSet('miniCart', {});
          setTimeout(() => {
            this.$router.push("/mainPage");
          }, 3000);
        }
      });
    },
  },
  created(){
    // Блокируем кнопку назад в телефоне
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', function (event){
      history.pushState(null, document.title, location.href);
    });
  }
};
</script>
<style lang="scss" scoped>
.shadow-block {
  min-height: 100%;
  width: 100%;
}
.container {
  overflow: hidden;
  position: relative;
  align-content: stretch;
}

form {
  width: 100%;
  padding-top: 60px;
  display: flex;
  // justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;

  .title {
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    text-transform: uppercase;
    color: #fff;
    margin-bottom: 15px;
  }
  textarea {
    width: 100%;
    height: 175px;
    padding: 8px;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 15px;
  }
  input[type="submit"] {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
    font-size: 18px;
    text-transform: uppercase;
    margin-top: auto;
  }
}
</style>